import * as React from "react";

function DatePickerType(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.686" height="17.799" viewBox="0 0 16.686 17.799">
     <path id="Icon_metro-calendar" data-name="Icon metro-calendar" d="M8.133,8.6h2.225v2.225H8.133Zm3.337,0h2.225v2.225H11.47Zm3.337,0h2.225v2.225H14.807ZM4.8,15.277H7.02V17.5H4.8Zm3.337,0h2.225V17.5H8.133Zm3.337,0h2.225V17.5H11.47ZM8.133,11.94h2.225v2.225H8.133Zm3.337,0h2.225v2.225H11.47Zm3.337,0h2.225v2.225H14.807ZM4.8,11.94H7.02v2.225H4.8ZM17.032,1.928V3.04H14.807V1.928H7.02V3.04H4.8V1.928H2.571v17.8H19.257V1.928H17.032Zm1.112,16.686H3.683V6.378H18.144Z" transform="translate(-2.571 -1.928)" fill={props.fill}/>
    </svg>

  );
}

export default  DatePickerType;
